<div [ngClass]="{ 'input-group-sm': small_input, 'input-group': true }">
  <input
    [(ngModel)]="authorSearchTerm"
    type="text"
    [appAutocomplete]="'/documents/get_authors'"
    [include_item]="include_item"
    (autocompleteSelect)="authorSearchOnSelect($event)"
    [placeholder]="placeholder || 'Search for author'"
    class="form-control"
    [disabled]="!select_only && (!!authorId || !editable)"
    name="author-search"
    ngDefaultControl
  />
  <div class="input-group-append" *ngIf="!select_only">
    <button type="button" class="btn btn-primary" [disabled]="!authorId || !editable" (click)="clearSelectedAuthor()">
      <span class="fas fa-pencil-alt"></span>
    </button>
  </div>
</div>
